module.exports = __webpack_public_path__ + "077960a40e09734e867d9862be903bba.svg";